// Court.jsx
import React from 'react';
import dayjs from 'dayjs';
import { GiTennisCourt } from "react-icons/gi";
import { Paper, Box, Typography, Stack } from '@mui/material';


const Court = ({ courtNumber, bookings, selectedDate, currentTime, handleClick }) => {
    // Die Erstellung der Timeslots
    const startTime = selectedDate.hour(8).minute(0).second(0).millisecond(0);
    const endTime = selectedDate.hour(24).minute(0).second(0);
    const timeSlots = [];

    let slot = startTime;
    while (slot.isBefore(endTime)) {
        timeSlots.push(slot);
        slot = slot.add(1, 'hour');
    }

    return (
        <Paper 
            elevation={3} 
            sx={{ 
                p: 2, 
                height: '100%', 
                borderRadius: 4, 
                bgcolor: 'rgba(255, 255, 255, 0.9)', 
                backdropFilter: 'blur(10px)',
                transition: 'transform 0.2s',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                }
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="center" gap={1} mb={2} pb={1} borderBottom={1} borderColor="divider">
                <GiTennisCourt size={24} color="#d32f2f" /> 
                <Typography variant="h6" fontWeight="bold" color="text.primary">
                    Platz {courtNumber}
                </Typography>
            </Stack>

            <Stack spacing={1}>
                {timeSlots.map((slotTime, i) => {
                    const slotEndTime = slotTime.add(1, "hour");
                    const booking = bookings.find(entry => {
                        const entryStart = dayjs(entry.startTime);
                        const entryEnd = dayjs(entry.endTime);
                        return entry.courtId === courtNumber &&
                               entryStart.isBefore(slotEndTime) &&
                               entryEnd.isAfter(slotTime);
                    });

                    const isOccupied = !!booking;
                    const isEvent = isOccupied && booking.eventId;
                    const isPast = currentTime.isAfter(slotTime) && !selectedDate.isAfter(currentTime, 'day'); // Fix: Past only if today or before, and time matches
                    
                    // Determine Status and Color
                    let statusBg = 'rgba(76, 175, 80, 0.08)';
                    let borderColor = 'success.light';
                    let isClickable = true;

                    if (isPast && !isOccupied) {
                        statusBg = 'rgba(0, 0, 0, 0.04)';
                        borderColor = 'transparent';
                        isClickable = false;
                    } else if (isEvent) {
                        statusBg = 'rgba(237, 108, 2, 0.15)';
                        borderColor = 'warning.main';
                    } else if (isOccupied) {
                        statusBg = 'rgba(211, 47, 47, 0.12)';
                        borderColor = 'error.main';
                    }

                    return (
                        <Box
                            key={i}
                            onClick={
                                (isClickable || isOccupied) // Occupied slots might be clickable for details
                                    ? () => handleClick(slotTime, isOccupied, courtNumber, booking)
                                    : null
                            }
                            sx={{
                                position: 'relative',
                                p: 1,
                                borderRadius: 2,
                                border: 1,
                                borderColor: borderColor,
                                bgcolor: statusBg,
                                cursor: (isClickable || isOccupied) ? 'pointer' : 'default',
                                transition: 'all 0.2s',
                                '&:hover': (isClickable || isOccupied) ? {
                                    bgcolor: isOccupied ? 'rgba(211, 47, 47, 0.2)' : 'rgba(76, 175, 80, 0.15)',
                                    transform: 'scale(1.02)'
                                } : {}
                            }}
                        >
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography variant="body2" fontWeight="500" color="text.secondary">
                                    {slotTime.format('HH:mm')}
                                </Typography>
                            </Stack>
                        </Box>
                    );
                })}
            </Stack>
        </Paper>
    );
};

export default Court;
